/** UN SDG locales supported by sdgs.un.org (official UN languages only; others fall back to English) */
const sdgSupportedLocales = new Set(['es', 'fr', 'ar', 'zh', 'ru']);
/** Locales that fall back to a supported SDG locale instead of English */
const sdgLocaleFallback: Record<string, string> = { ca: 'es', gl: 'es', eu: 'es' };

/** Map SDG number to its official UN goal URL, locale-aware */
export function sdgGoalUrl(goal: number, locale: string): string {
	const resolvedLocale = sdgLocaleFallback[locale] ?? locale;
	const localePrefix = sdgSupportedLocales.has(resolvedLocale) ? `${resolvedLocale}/` : '';
	return `https://sdgs.un.org/${localePrefix}goals/goal${goal}`;
}
